import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { mdiDeleteSweep } from '@mdi/js';
import { Icon } from '@mdi/react';
import { Button } from '@mui/material';
import { Box } from '@mui/system';
import { useCallback, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { useMutation } from '@tanstack/react-query';
import { toast } from 'react-toastify';
import DefaultBackdrop from '../../../components/DefaultBackdrop/DefaultBackdrop';
import { useSTContext } from '../../SmartTableContext';
import { rowsSortingToSortDto } from '../../../api/helpers';
import DeleteDuplicatesDialog from './DeleteDuplicatesDialog';
const DeleteDuplicatesButton = () => {
    const table = useSTContext();
    const { sorting, rowFilterCondition, totalRows, api } = table;
    const [open, setOpen] = useState(false);
    const handleClose = useCallback(() => setOpen(false), []);
    const mutation = useMutation({
        mutationFn: async ({ condition }) => {
            if (!api.deleteDuplicatesApiCall) {
                throw new Error('deleteDuplicatesApiCall is not implemented');
            }
            const res = await api.deleteDuplicatesApiCall(condition);
            return res;
        },
        onSuccess: () => {
            // remove timeout if check by view is implemented
            setTimeout(() => {
                table.invalidateTable();
                toast(_jsx(FormattedMessage, { id: "table.deleteDuplicity.success", defaultMessage: "All hightlighted duplicates were deleted" }), {
                    type: 'success',
                });
            }, 500);
        },
    });
    const handleOk = useCallback(() => {
        mutation.mutate({
            condition: {
                andConditions: rowFilterCondition?.andConditions ?? [],
                sorting: rowsSortingToSortDto(sorting),
                maxRecords: totalRows,
            },
        });
        setOpen(false);
    }, [mutation, rowFilterCondition?.andConditions, sorting, totalRows]);
    const handleDeleteDuplicates = useCallback(() => setOpen(true), []);
    return (_jsxs(_Fragment, { children: [_jsx(Box, { children: _jsx(Button, { size: "small", variant: "outlined", color: "error", onClick: handleDeleteDuplicates, startIcon: _jsx(Icon, { path: mdiDeleteSweep, size: 1 }), children: _jsx(FormattedMessage, { id: "table.deleteDuplicity.button", defaultMessage: "Delete duplicity" }) }) }), open && _jsx(DeleteDuplicatesDialog, { open: open, onClose: handleClose, onOk: handleOk }), _jsx(DefaultBackdrop, { isLoading: mutation.isPending })] }));
};
export default DeleteDuplicatesButton;
//# sourceMappingURL=DeleteDuplicatesButton.js.map